module.exports = __webpack_public_path__ + "static/media/summerUnion.7c87cce6.jpg";